module.exports = __webpack_public_path__ + "img/leabank.6a284f4.png";